import React from 'react';
import { Card } from 'react-bootstrap';
import AuthStepProvider from '../../auth/context/AuthStepContext';
import SignIn from '../../auth/pages/SignIn';

const AuthenticationCard: React.FC = () => {
  return (
    <Card>
      <Card.Header style={{ height: '70px' }} />
      <Card.Body>
        <AuthStepProvider>
          <SignIn />
        </AuthStepProvider>
      </Card.Body>
    </Card>
  );
};

export default AuthenticationCard;
